import { get, post } from '@/services/http';
import { UserDashboardModel } from '@/models/user_dashboard';
import List from './list';

interface SearchParams {
  name?: string;
}

export class UserDashboardList extends List<UserDashboardModel> {
  public lastPage!: number;
  public mapData(data: any = []) {
    for (const s of data) {
      const dashboard = new UserDashboardModel();
      dashboard.mapData(s);
      this.add(dashboard);
    }
  }

  public async fetch(
    page: number = 1,
    pageSize: number = 50,
    params: SearchParams = {},
    ) {
      const data: any = {
        page,
        per_page: pageSize,
        ...params,
      };
      const res: any = await get(`/dashboards`, data);
      const dashboards = res.data.rows || [];
      this.lastPage = Number((res.data.count / pageSize).toFixed(0));
      if (res.data.count / pageSize > this.lastPage) {
        this.lastPage = this.lastPage + 1;
      }
      for (const s of dashboards) {
        const dashboard: UserDashboardModel = new UserDashboardModel();
        dashboard.mapData(s);
        this.add(dashboard);
      }
  }
}
